<div class="row" *ngIf="!noCharacteristicsData;else noData">
  <div>
    <table class="width">
      <tr class="equity-characteristics-header" *ngIf="!portfolioModel?.profileData?.isMarketNeutralFund">
        <th class="row-header">Fundamental</th>
        <th>{{fundId}}</th>
        <th *ngIf="(!portfolioModel?.profileData?.isExternalFund)">
          <div class="tool-tip-cell" *ngIf="(!portfolioModel?.profileData?.isBalanced)">
            <label>Benchmark<sup *ngIf="portfolioModel?.profileData?.isBalanced">{{benchmarkFootNote?.id}}</sup></label>
              <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
                <span c11nTooltipContent>{{ equityCharacteristic?.benchmarkShortName }}</span>
              </c11n-tooltip>
          </div>
          <div class="tool-tip-cell" *ngIf="(portfolioModel?.profileData?.isBalanced)">
              <label>Benchmark<sup *ngIf="(portfolioModel?.profileData?.isBalanced) ||(!portfolioModel?.profileData?.isExternalFund)">{{benchmarkFootNote?.id}}</sup></label>
              <c11n-tooltip  [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
                <span c11nTooltipContent>{{ equityCharacteristic?.benchmarkShortName}}</span>
              </c11n-tooltip>
          </div>
        </th>
      </tr>
      <tr class="equity-characteristics-header" *ngIf="portfolioModel?.profileData?.isMarketNeutralFund">
        <th class="row-header">Fundamental</th>
        <th>Long Portfolio</th>
        <th>Short Portfolio</th>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header">Number of stocks</td>
        <td data-rpa-tag-id="symbolNumberOfStocks">
          {{ equityCharacteristic?.fund?.numberOfStocks ?equityCharacteristic?.fund?.numberOfStocks: '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkNumberOfStocks">
          {{ equityCharacteristic?.benchmark?.numberOfStocks ? equityCharacteristic?.benchmark?.numberOfStocks:
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.numberOfStocksShort ? equityCharacteristic?.fund?.numberOfStocksShort:
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header">Median market cap</td>
        <td data-rpa-tag-id="symbolMedianMarketCap">
          {{ equityCharacteristic?.fund ?.medianMarketCap ? (equityCharacteristic?.fund ?.medianMarketCap | amount) :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund  && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkMedianMarketCap">
          {{ equityCharacteristic?.benchmark ?.medianMarketCap ? (equityCharacteristic?.benchmark ?.medianMarketCap |
          amount) : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund  && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund ?.medianMarketCapShort ? (equityCharacteristic?.fund ?.medianMarketCapShort |
          amount) : '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header"><a class="link equity-link" role="button" tabindex="0"
            (click)="setDialogInfo('Earnings growth rate');equityCharacteristicDialog.openModalDialog();"
            href="javascript:void(0)">Earnings growth rate</a>
        </td>
        <td data-rpa-tag-id="symbolEarningGrowthRate">
          {{ equityCharacteristic?.fund?.earningsGrowthRate ? equityCharacteristic?.fund?.earningsGrowthRate + '%':
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund  && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkEarningGrowthRate">
          {{ equityCharacteristic?.benchmark?.earningsGrowthRate ? equityCharacteristic?.benchmark?.earningsGrowthRate +
          '%': '&mdash;' }}
        </td>

        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund  && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.earningsGrowthRateShort ? equityCharacteristic?.fund?.earningsGrowthRateShort +
          '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics" *ngIf="((!portfolioModel?.profileData?.isMarketNeutralFund && ((!portfolioModel?.profileData?.isETF &&
    !portfolioModel?.profileData?.isBalanced) || portfolioModel?.profileData?.isETF)) ||
    (portfolioModel?.profileData?.isMarketNeutralFund && !portfolioModel?.profileData?.isBalanced))">
        <td class="row-header">Short-term reserves</td>
        <td data-rpa-tag-id="symbolShortTermReserve">
          {{ equityCharacteristic?.fund?.shortTermReserves ? equityCharacteristic?.fund?.shortTermReserves + '%' :
          '&mdash;' }}
        </td>
        <td *ngIf="!portfolioModel?.profileData?.isExternalFund" data-rpa-tag-id="benchmarkShortTermReserve">
          {{ equityCharacteristic?.benchmark?.shortTermReserves ? equityCharacteristic?.benchmark?.shortTermReserves +
          '%' : '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header"><a class="link equity-link" role="button" tabindex="0" aria-label="Price Earnings Ratio"
            (click)="setDialogInfo('Price/earnings ratio');equityCharacteristicDialog.openModalDialog();" href="javascript:void(0)">P/E
            ratio</a></td>
        <td data-rpa-tag-id="symbolP/eRatio">
          {{ equityCharacteristic?.fund?.priceEarningsRatio ? equityCharacteristic?.fund?.priceEarningsRatio : '&mdash;'
          }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkP/eRatio">
          {{ equityCharacteristic?.benchmark?.priceEarningsRatio ? equityCharacteristic?.benchmark?.priceEarningsRatio :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.priceEarningsRatioShort ? equityCharacteristic?.fund?.priceEarningsRatioShort :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header"><a class="link equity-link" role="button" tabindex="0" aria-label="Price Book Ratio"
            (click)="setDialogInfo('Price/book ratio');equityCharacteristicDialog.openModalDialog();" href="javascript:void(0)">P/B
            ratio</a></td>
        <td data-rpa-tag-id="symbolP/bRatio"> {{ equityCharacteristic?.fund?.priceBookRatio ?
          equityCharacteristic?.fund?.priceBookRatio : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkP/bRatio">
          {{ equityCharacteristic?.benchmark?.priceBookRatio ? equityCharacteristic?.benchmark?.priceBookRatio :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.priceBookRatioShort ? equityCharacteristic?.fund?.priceBookRatioShort :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics" *ngIf="!portfolioModel?.profileData?.isBalanced">
        <td class="row-header">
          Turnover rate (Fiscal Year-end {{equityCharacteristic?.fund?.turnoverRateDate | ESTPipe }})
        </td>
        <td data-rpa-tag-id="symbolTurnoverRate"> {{ equityCharacteristic?.fund?.turnoverRate ?
          equityCharacteristic?.fund?.turnoverRate + '%' : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkTurnoverRate">
          {{ equityCharacteristic?.benchmark?.turnoverRate ? equityCharacteristic?.benchmark?.turnoverRate + '%' :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header"><a class="link equity-link" role="button" tabindex="0" aria-label="Return on Equity"
            (click)="setDialogInfo('Return on equity');equityCharacteristicDialog.openModalDialog();" href="javascript:void(0)">Return on
            equity</a></td>
        <td data-rpa-tag-id="symbolReturnOnEquity">
          {{ equityCharacteristic?.fund?.returnOnEquity ? equityCharacteristic?.fund.returnOnEquity + '%' : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkReturnOnEquity">
          {{ equityCharacteristic?.benchmark?.returnOnEquity ? equityCharacteristic?.benchmark?.returnOnEquity + '%' :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.returnOnEquityShort ? equityCharacteristic?.fund?.returnOnEquityShort + '%' :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics">
        <td class="row-header">Foreign holdings</td>
        <td data-rpa-tag-id="symbolForeignHoldings">
          {{ equityCharacteristic?.fund?.foreignHolding ? equityCharacteristic?.fund?.foreignHolding + '%' : '&mdash;'
          }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && !portfolioModel?.profileData?.isMarketNeutralFund)"
          data-rpa-tag-id="benchmarkForeignHoldings">
          {{ equityCharacteristic?.benchmark?.foreignHolding ? equityCharacteristic?.benchmark?.foreignHolding + '%' :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund && portfolioModel?.profileData?.isMarketNeutralFund)">
          {{ equityCharacteristic?.fund?.foreignHoldingShort ? equityCharacteristic?.fund?.foreignHoldingShort + '%' :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics"
        *ngIf="!portfolioModel?.profileData?.isMarketNeutralFund && !portfolioModel?.profileData?.isBalanced">
        <td class="row-header">Fund total net assets as of
          {{ equityCharacteristic?.fund?.totalNetAssetsDate | ESTPipe }}</td>
        <td data-rpa-tag-id="symbolFundNetAssets">
          {{ equityCharacteristic?.fund?.totalNetAssets ? (equityCharacteristic?.fund?.totalNetAssets | amount) :
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkFundNetAssets">
          {{ equityCharacteristic?.benchmark?.totalNetAssets ? (equityCharacteristic?.benchmark?.totalNetAssets |
          amount) : '&mdash;' }}
        </td>
      </tr>
      <tr class="equity-characteristics" *ngIf="!portfolioModel?.profileData?.isMarketNeutralFund && !portfolioModel?.profileData?.isBalanced
      && portfolioModel?.profileData?.hasMoreThan1ShareClass">
        <td class="row-header">Share class total net assets</td>
        <td data-rpa-tag-id="symbolShareNetAssets">
          {{ equityCharacteristic?.fund?.shareClassTotalNetAssets ?
          (equityCharacteristic?.fund?.shareClassTotalNetAssets | amount) : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkShareNetAssets">
          {{ equityCharacteristic?.benchmark?.shareClassTotalNetAssets ?
          (equityCharacteristic?.benchmark?.shareClassTotalNetAssets | amount) : '&mdash;' }}
        </td>
      </tr>
    </table>
  </div>
</div>

<ng-template #noData>
  <p *ngIf="noCharacteristicsData" class="no-data">This information is temporarily unavailable.</p>
</ng-template>

<c11n-modal-dialog
  modalId="equityCharacteristicDialog"
  [headingText]="dialogTitle"
  #equityCharacteristicDialog>
  <div c11n-modal-dialog-body>
    <p [innerHTML]="dialogBody"></p>
  </div>
</c11n-modal-dialog>
